import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { Hint } from '@tecsinapse/cortex-react'
import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import FormSingleSelect from '../../hook-form-connectors/form-single-select'
import { GrupoUsuariosValues } from '../hooks/use-form'

const options = [
  { label: t`Privado`, value: false },
  { label: t`Público`, value: true }
]

export const PodeCriarGrupoPublico = () => {
  const { publico, id: isDisabled } = useWatch<GrupoUsuariosValues>()

  const { setValue } = useFormContext()

  return (
    <div className={'sm:w-[50%]'}>
      <p className={'font-bold mb-mili'}>
        <Trans>Visibilidade do grupo:</Trans>
      </p>
      <FormSingleSelect
        name='publico'
        options={options}
        customOnChange={({ value }) => {
          setValue('publico', value)
        }}
        disabled={isDisabled}
        customValue={publico ? options[1] : options[0]}
      />
      <Hint>
        <Trans>
          Escolha se este grupo será visível apenas para você (privado) ou para
          todos os usuários (público).
        </Trans>
      </Hint>
    </div>
  )
}
